module.exports = __webpack_public_path__ + "static/2ndFloor-Mobile-10-27-e0fd81606f7f3f034a5dc892fa9c23b7.jpg";